/**
 * TanStack Query hooks for `ccpa-dsr`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	patchStatus,
	ccpaDsrQueryKeys,
	type CreateCcpaRequestBody,
	type CreateCcpaRequestResponse,
	type CcpaRequestRow,
	type CcpaRequestStatus,
	type PatchCcpaStatusBody,
} from "./api";

export function useCcpaDsrList(
	statusFilter?: CcpaRequestStatus,
): UseQueryResult<CcpaRequestRow[], Error> {
	return useQuery({
		queryKey: ccpaDsrQueryKeys.list(statusFilter),
		queryFn: () => list(statusFilter),
	});
}

export function useCcpaDsrCreate(): UseMutationResult<
	CreateCcpaRequestResponse,
	Error,
	CreateCcpaRequestBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ccpaDsrQueryKeys.all });
		},
	});
}

export interface PatchStatusVars {
	id: string;
	body: PatchCcpaStatusBody;
}

export function useCcpaDsrPatchStatus(): UseMutationResult<
	CcpaRequestRow,
	Error,
	PatchStatusVars
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (vars: PatchStatusVars) => patchStatus(vars.id, vars.body),
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ccpaDsrQueryKeys.all });
		},
	});
}
